import { Pipe, PipeTransform } from '@angular/core'
import { NounsInterface } from './nouns.interface'

@Pipe({
    name: 'conjugationPipe',
    standalone: false
})
export abstract class ConjugationPipe implements PipeTransform {

    transform(subjects: Array<Object>, nouns: NounsInterface, always?: boolean): string {
        if (!subjects) {
            return ''
        }
        else if (subjects.length >= 5) {
            return `${subjects.length} ${nouns.fiveOrMore}`
        }
        else if (subjects.length > 1) {
            return `${subjects.length} ${nouns.twoToFour}`
        } else if (always && subjects.length === 1) {
            return `1 ${nouns.one}`
        }
    }

}